import ic_a from "../assets/ic_a.png";
import ic_b from "../assets/ic_b.png";
import ic_e from "../assets/ic_e.png";
import ic_f from "../assets/ic_f.png";
import ic_g from "../assets/ic_g.png";
import ic_h from "../assets/ic_h.png";
import ic_i from "../assets/ic_i.png";
import ic_l from "../assets/ic_l.png";
import ic_m from "../assets/ic_m.png";
import ic_o from "../assets/ic_o.png";
import ic_q from "../assets/ic_q.png";
import ic_s from "../assets/ic_s.png";
import ic_t from "../assets/ic_t.png";

// Mapa que relaciona el título de la materia con su imagen
const imagenesMaterias = {
  "a": ic_a,
  "b": ic_b,
  "e": ic_e,
  "f": ic_f,
  "h": ic_h,
  "i": ic_i,
  "l": ic_l,
  "m": ic_m,
  "o": ic_o,
  "q": ic_q,
  "s": ic_s,
  "t": ic_t
};

export default imagenesMaterias;
